import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FiArrowLeft } from 'react-icons/fi';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from 'recharts';

// --- TELJES FORDÍTÁSI TÁBLÁZAT SZINKRONIZÁLVA ---
const translationMap = {
  'mini': 'Mini', 'gyerek': 'Gyerek', 'junior': 'Junior', 'kadet': 'Kadét',
  'fiatal_felnott': 'Fiatal felnőtt', 'felnott': 'Felnőtt', 'szenior': 'Szenior', 'veteran': 'Veterán',
  '3d_hdh_bb': 'BB (Barebow)', '3d_hdh_bg': 'BG (Fúvócső)', '3d_hdh_cb': 'CB (Csigás Barebow)',
  '3d_hdh_crb': 'CRB (Számszeríj)', '3d_hdh_cu': 'CU (Scope-os Csigás)', '3d_hdh_hu': 'HU (Vadász Csigás)',
  '3d_hdh_ol': 'OL (Olimpiai)', '3d_hdh_pbhb': 'PBHB (Pusztai íj (Tradi))', '3d_hdh_trlb': 'TRLB (Longbow)',
  '3d_hdh_trrb': 'TRRB (Vadászreflex)',
  '3d_ifaa_bbc': 'BB(C) (Barebow-Csigás)', '3d_ifaa_bbr': 'BB(R) (Barebow-Reflex)',
  '3d_ifaa_bhc': 'BH(C) (Vadászijász-Csigás)', '3d_ifaa_bhr': 'BH(R) (Vadászijász-Reflex)',
  '3d_ifaa_bl': 'BL (Korlátozott Vadászijász)', '3d_ifaa_bu': 'BU (Bowhunter Unlimited)',
  '3d_ifaa_fsc': 'FS(C) (Korl. nyílt o.-Csigás)', '3d_ifaa_fsr': 'FS(R) (Korl. nyílt o.-Reflex)',
  '3d_ifaa_fu': 'FU (Korlátlan nyílt osztály)', '3d_ifaa_hb': 'HB (Történelmi íj)',
  '3d_ifaa_hbm': 'HB(M) (Történelmi íj modern)', '3d_ifaa_lb': 'LB (Longbow)',
  '3d_ifaa_tr': 'TR (Tradicionális reflex)',
  'terep_olimpiai': 'OL (Olimpiai)', 'terep_csigas': 'CU (Scope-os Csigás)', 'terep_barebow': 'BB (Barebow)',
  'terep_cb': 'CB (Csigás Barebow)', 'terep_hu': 'HU (Vadász Csigás)', 'terep_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'terep_trlb': 'TRLB (Longbow)', 'terep_trrb': 'TRRB (Vadászreflex)',
  'palya_wa_ol': 'R (Olimpiai reflexíj)', 'palya_wa_cu': 'CU (Scope-os Csigás)', 'palya_wa_hu': 'HU (Vadász Csigás)',
  'palya_wa_bb': 'B (Barebow)', 'palya_wa_trrb': 'TRRB (Vadászreflex)', 'palya_wa_trlb': 'TRLB (Longbow)',
  'palya_wa_pbhb': 'PBHB (Pusztai íj (Tradi))', 'palya_wa_crb': 'CRB (Számszeríj)',
  'palya_ifaa_fu': 'FU (Freestyle Unlimited)', 'palya_ifaa_fsr': 'FSR (FSR (Freestyle Ltd Recurve))',
  'palya_ifaa_fsc': 'FSC (FSC (Freestyle Ltd Compound))', 'palya_ifaa_bbr': 'BBR (Barebow-Reflex)',
  'palya_ifaa_bbc': 'BBC (Barebow-Csigás)', 'palya_ifaa_bu': 'BU (Bowhunter Unlimited)',
  'palya_ifaa_bl': 'BL (Bowhunter Limited)', 'palya_ifaa_bhc': 'BHC (Vadászijász-Csigás)',
  'palya_ifaa_bhr': 'BHR (Vadászijász-Reflex)', 'palya_ifaa_lb': 'LB (Longbow)',
  'palya_ifaa_hb': 'HB (Historical Bow)', 'palya_ifaa_tr': 'TR (Traditional Bow)',
  'tortenelmi_pusztai_modern': 'Modern pusztai íj', 'tortenelmi_pusztai_termeszetes': 'Természetes pusztai íj',
  'tortenelmi_botij': 'Történelmi hosszúíj / Botíj', 'tortenelmi_vadaszij': 'Hagyományos vadászíj',
  'tortenelmi_szamszerij': 'Történelmi számszeríj', 'tortenelmi_bb': 'BB (Barebow)',
  'orom_wa_ol': 'OL (Olimpiai reflexíj)', 'orom_wa_cu': 'CU (Scope-os Csigás)', 'orom_wa_hu': 'HU (Vadász Csigás)',
  'orom_wa_cb': 'CB (Csigás Barebow)', 'orom_wa_bb': 'BB (Barebow)', 'orom_wa_trrb': 'TRRB (Vadászreflex)',
  'orom_wa_trlb': 'TRLB (Longbow)', 'orom_wa_pbhb': 'PBHB (Pusztai íj)', 'orom_wa_crb': 'CRB (Számszeríj)',
  'orom_wa_bg': 'BG (Fúvócső)',
  'egyeb_wa_ol': 'OL (Olimpiai reflexíj)', 'egyeb_wa_cu': 'CU (Scope-os Csigás)', 'egyeb_wa_hu': 'HU (Vadász Csigás)',
  'egyeb_wa_cb': 'CB (Csigás Barebow)', 'egyeb_wa_bb': 'BB (Barebow)', 'egyeb_wa_trrb': 'TRRB (Vadászreflex)',
  'egyeb_wa_trlb': 'TRLB (Longbow)', 'egyeb_wa_pbhb': 'PBHB (Pusztai íj)', 'egyeb_wa_crb': 'CRB (Számszeríj)',
  'egyeb_wa_bg': 'BG (Fúvócső)', 'egyeb_altalanos': 'Egyéb Általános'
};

const getColorForZoneValue = (val) => {
    const v = val?.toString().toUpperCase();
    if (v === '11' || v === 'X') return '#4CAF50';
    if (v === '10' || v === '9') return '#FFD700';
    if (v === '8' || v === '7') return '#F44336';
    if (v === '6' || v === '5') return '#1976D2';
    return '#9E9E9E';
};

// --- ÚJ: KLUB NÉV FORMÁZÓ SEGÉDFÜGGVÉNY ---
const formatClubName = (name) => {
  if (!name || name === "Egyéb" || name === "N/A" || name === "Ismeretlen" || name === "Egyéni induló") return name;
  const specialCases = {
      "3d": "3D", "kft.": "Kft.", "se": "SE", "sk": "SK", "dse": "DSE",
      "kse": "KSE", "mavir": "MAVIR", "ifaa": "IFAA", "hdh-iaa": "HDH-IAA"
  };

  return name.split(' ').map(word => {
    const cleanWord = word.replace(/[^a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ0-9]/g, '').toLowerCase();
    if (specialCases[cleanWord]) return specialCases[cleanWord];
    if (word.startsWith('"')) {
        return '"' + (word.charAt(1)?.toUpperCase() || "") + word.slice(2).toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
};

const CompetitorResultView = () => {
    const { compId, pId } = useParams();
    const navigate = useNavigate();
    const [participant, setParticipant] = useState(null);
    const [competition, setCompetition] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        const fetchData = async () => {
            setLoading(true);
            try {
                let compDoc = await getDoc(doc(db, 'events_closed', compId));
                if (!compDoc.exists()) {
                    compDoc = await getDoc(doc(db, 'events', compId));
                }
                if (compDoc.exists()) {
                    setCompetition(compDoc.data());
                }

                const docRef = doc(db, 'events_closed', compId, 'participants', pId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setParticipant(docSnap.data());
                } else {
                    alert("A versenyző adatai nem találhatók!");
                    navigate(`/eredmeny/${compId}`);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

        return () => window.removeEventListener('resize', handleResize);
    }, [compId, pId, navigate]);

    const groupedShots = useMemo(() => {
        if (!participant) return [];
        const rawShots = participant.finalShots || participant.shots || [];
        if (!Array.isArray(rawShots) || rawShots.length === 0) return [];

        const numTargets = Number(competition?.numberOfTargets) || 24;
        const shotsPerT = Number(competition?.shotsPerTarget) || 3;
        const allOnFirst = rawShots.every(s => (parseInt(s.target) || 1) <= 1);
        const wrongDistribution = rawShots.some(s => parseInt(s.target) > numTargets);

        let processedRawShots = rawShots;
        if (allOnFirst || wrongDistribution) {
             processedRawShots = rawShots.map((s, idx) => ({
                ...s,
                target: Math.floor(idx / shotsPerT) + 1
             }));
        }

        const grouped = processedRawShots.reduce((acc, s) => {
            const t = parseInt(s.target) || 1;
            if (!acc[t]) acc[t] = [];
            const valStr = s.value?.toString() || "";
            const safeValue = (valStr.length > 2) ? (s.sum?.toString() || "0") : valStr;
            if (safeValue !== "") {
                acc[t].push({ ...s, value: safeValue });
            }
            return acc;
        }, {});

        const sortedTargets = Object.keys(grouped).sort((a, b) => parseInt(a) - parseInt(b));
        if (sortedTargets.length === 0) return [];

        let runningTotal = 0;
        return sortedTargets.map(targetNum => {
            const shots = grouped[targetNum] || [];
            const seriesScore = shots.reduce((acc, s) => acc + (parseInt(s.sum) || 0), 0);
            runningTotal += seriesScore;
            return { targetNum, shots, seriesScore, runningTotal, type: 'detailed' };
        });
    }, [participant, competition]);

    // ÚJ: Grafikon adatok előkészítése
    const chartData = useMemo(() => {
        const rawShots = participant?.finalShots || participant?.shots || [];
        if (!Array.isArray(rawShots) || rawShots.length === 0) return [];

        const data = [];
        let sum = 0;
        rawShots.forEach((s, idx) => {
            sum += (parseInt(s.sum) || 0);
            data.push({
                name: idx + 1,
                average: parseFloat((sum / (idx + 1)).toFixed(2))
            });
        });
        return data;
    }, [participant]);

    if (loading) return <div style={centerStyle}>Eredménylap betöltése... 🏹</div>;
    if (!participant) return null;

    const hasShots = groupedShots.length > 0;

    // VÍZJEL MEGJELENÍTÉSE
    const rawShotsForWatermark = participant.finalShots || participant.shots || [];
    const allOnFirst = rawShotsForWatermark.length > 0 && rawShotsForWatermark.every(s => (parseInt(s.target) || 1) <= 1);
    const hasWrongDistribution = rawShotsForWatermark.length > 0 && rawShotsForWatermark.some(s => parseInt(s.target) > (Number(competition?.numberOfTargets) || 24));
    const shouldShowWatermark = participant.isManuallyEdited || allOnFirst || hasWrongDistribution;

    return (
        <div style={containerStyle} className="force-light-theme">
            <button onClick={() => navigate(`/eredmeny/${compId}`)} style={backBtnStyle}>
                <FiArrowLeft /> Vissza a rangsorhoz
            </button>

            {/* FEJLÉC KÁRTYA */}
            <div style={headerCardStyle}>
                <div style={{ ...headerMainRow, flexWrap: 'nowrap', gap: isMobile ? '10px' : '20px' }}>
                    <div style={{ ...infoSection, minWidth: '0' }}>
                        <h1 style={{ ...nameStyle, fontSize: isMobile ? '1.4rem' : '1.8rem' }}>{participant.fullName}</h1>
                        <div style={clubStyle}>{formatClubName(participant.club) || 'Egyéni induló'}</div>
                        <div style={{ ...categoryBadge, fontSize: isMobile ? '0.7rem' : '0.85rem' }}>
                            {(translationMap[participant.bowCategory?.toLowerCase()] || participant.bowCategory)} - {(translationMap[participant.ageCategory?.toLowerCase()] || participant.ageCategory)} - {participant.gender}
                        </div>
                    </div>
                    <div style={{ ...scoreSection, padding: isMobile ? '10px 15px' : '15px 25px', flexShrink: 0 }}>
                        <div style={scoreLabel}>ÖSSZPONTSZÁM</div>
                        <div style={{ ...scoreValue, fontSize: isMobile ? '1.8rem' : '2.5rem' }}>{participant.totalScore}</div>
                        {hasShots && (
                          <div style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#888', marginTop: '5px' }}>
                            Átlag: {(participant.totalScore / (participant.finalShots?.length || participant.shots?.length || 1)).toFixed(2)}
                          </div>
                        )}
                    </div>
                </div>
            </div>

            {/* ÚJ: ZÓNA STATISZTIKA KÁRTYA */}
            {hasShots && (
                <div style={zoneStatsCardStyle}>
                    <div style={{ fontSize: '0.7rem', color: '#888', fontWeight: 'bold', marginBottom: '15px', textTransform: 'uppercase' }}>
                        Találatok eloszlása
                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? 'repeat(5, 1fr)' : 'repeat(auto-fit, minmax(80px, 1fr))',
                        gap: isMobile ? '8px' : '15px',
                        width: '100%'
                    }}>
                        {Object.entries(
                            (participant.finalShots || participant.shots || []).reduce((acc, s) => {
                                const v = s.value?.toString() || "";
                                if (v) acc[v] = (acc[v] || 0) + 1;
                                return acc;
                            }, {})
                        )
                        .sort(([a], [b]) => {
                            const valA = a === 'X' ? 11.5 : (parseInt(a) || 0);
                            const valB = b === 'X' ? 11.5 : (parseInt(b) || 0);
                            return valB - valA;
                        })
                        .map(([zone, count]) => (
                            <div key={zone} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                <div style={{...zoneBadgeStyle(zone), width: isMobile ? '100%' : '80%', boxSizing: 'border-box'}}>{zone}</div>
                                <div style={{ fontSize: isMobile ? '0.75rem' : '0.9rem', fontWeight: 'bold', color: '#333' }}>{count} db</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* ÚJ: GRAFIKON KÁRTYA */}
            {chartData.length > 0 && (
                <div style={{ ...chartCardStyle, padding: isMobile ? '12px' : '20px' }}>
                    <div style={{ fontSize: '0.65rem', color: '#888', fontWeight: 'bold', marginBottom: isMobile ? '8px' : '15px', textTransform: 'uppercase' }}>
                        Lövésátlag alakulása
                    </div>
                    <div style={{ height: isMobile ? '140px' : '200px', width: '100%' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={chartData}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" hide />
                                <YAxis
                                    domain={['dataMin - 0.5', 'dataMax + 0.5']} // JAVÍTÁS: Dinamikus skálázás (zoom)
                                    width={isMobile ? 25 : 30}
                                    fontSize={10}
                                />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="average"
                                    stroke="#4CAF50"
                                    strokeWidth={3}
                                    dot={false}
                                    name="Átlag"
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            )}

            {/* LÖVÉSLISTA TÁBLÁZAT */}
            <div style={{ ...listCardStyle, position: 'relative' }}>

                {/* VÍZJEL KONTEÉNER (FIXEN A KÉPERNYŐN) */}
                {shouldShowWatermark && hasShots && (
                  <div style={watermarkFixedContainerStyle}>
                    <div style={{
                        ...watermarkStickyTextStyle,
                        fontSize: isMobile ? '1.5rem' : '2.5rem'
                    }}>
                      A találatok manuálisan<br/>lettek rögzítve
                    </div>
                  </div>
                )}

                <div style={tableHeader}>
                    <div style={{ width: '40px', fontWeight: 'bold', color: '#888' }}>#</div>
                    <div style={{ flex: 1, fontWeight: 'bold', color: '#888' }}>TALÁLATOK</div>
                    <div style={{ width: '60px', textAlign: 'right', fontWeight: 'bold', color: '#888' }}>CÉL</div>
                    <div style={{ width: '80px', textAlign: 'right', fontWeight: 'bold', color: '#333' }}>ÖSSZ.</div>
                </div>

                <div style={listContainer}>
                    {hasShots ? (
                      groupedShots.map((item, idx) => {
                        const isStartTarget = parseInt(item.targetNum) === parseInt(participant.team);

                        return (
                          <div key={idx} style={{
                            ...rowStyle,
                            position: 'relative',
                            zIndex: 1,
                            backgroundColor: isStartTarget ? '#fff9c4' : 'transparent', // Halvány sárga kiemelés a start célnak
                            borderLeft: isStartTarget ? '4px solid #b30000' : 'none'
                          }}>
                            <div style={{ ...targetNumStyle, color: isStartTarget ? '#b30000' : '#888' }}>
                                #{item.targetNum}{isStartTarget && <span style={{ fontSize: '0.6rem', display: 'block' }}>START</span>}
                            </div>
                            <div style={shotsWrapper}>
                                {item.shots.map((s, sIdx) => (
                                    <div key={sIdx} style={shotBadgeStyle(s.value)}>
                                        {s.value}
                                    </div>
                                ))}
                            </div>
                            <div style={seriesScoreStyle}>{item.seriesScore}</div>
                            <div style={runningTotalStyle}>{item.runningTotal}</div>
                          </div>
                        );
                      })
                    ) : (
                      <div style={{ padding: '40px 20px', textAlign: 'center', color: '#888', fontStyle: 'italic' }}>
                        Ehhez a nevezőhöz csak az összpontszám lett rögzítve.
                      </div>
                    )}
                </div>
            </div>

            <div style={{ height: '80px' }} />
        </div>
    );
};

// --- STÍLUSOK ---
const containerStyle = { padding: '12px', maxWidth: '800px', margin: '0 auto', backgroundColor: '#f4f6f8', minHeight: '100vh', fontFamily: 'Arial, sans-serif' };
const backBtnStyle = { display: 'flex', alignItems: 'center', gap: '8px', border: 'none', background: 'none', color: '#666', fontWeight: 'bold', cursor: 'pointer', marginBottom: '15px' };
const headerCardStyle = { backgroundColor: '#fff', borderRadius: '15px', padding: '20px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '10px', borderTop: '5px solid #b30000' };
const headerMainRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px' };
const infoSection = { flex: 1, minWidth: '200px' };
const nameStyle = { margin: '0 0 5px 0', fontSize: '1.8rem', fontWeight: '900', color: '#333' };
const clubStyle = { color: '#666', fontSize: '1rem', marginBottom: '10px' };
const categoryBadge = { display: 'inline-block', backgroundColor: '#fbeaea', color: '#b30000', padding: '4px 12px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 'bold' };
const scoreSection = { textAlign: 'center', backgroundColor: '#f8f9fa', padding: '15px 25px', borderRadius: '12px', border: '1px solid #eee' };
const scoreLabel = { fontSize: '0.7rem', color: '#888', fontWeight: 'bold', letterSpacing: '1px' };
const scoreValue = { fontSize: '2.5rem', fontWeight: '900', color: '#b30000', lineHeight: '1' };

const chartCardStyle = { backgroundColor: '#fff', borderRadius: '15px', padding: '20px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '10px' };

const zoneStatsCardStyle = { backgroundColor: '#fff', borderRadius: '15px', padding: '15px 20px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '10px' };

const listCardStyle = { backgroundColor: '#fff', borderRadius: '15px', overflow: 'visible', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' };
const tableHeader = { display: 'flex', padding: '10px 20px', backgroundColor: '#f2f2f2', fontSize: '0.8rem', borderBottom: '1px solid #eee', position: 'sticky', top: '0', zIndex: 5 };
const listContainer = { padding: '10px 0' };
const rowStyle = { display: 'flex', alignItems: 'center', padding: '12px 20px', borderBottom: '1px solid #f0f0f0' };
const targetNumStyle = { width: '40px', fontWeight: 'bold', color: '#888', fontSize: '0.9rem' };
const shotsWrapper = { flex: 1, display: 'flex', gap: '6px', flexWrap: 'wrap' };
const seriesScoreStyle = { width: '60px', textAlign: 'right', color: '#666', fontSize: '1rem' };
const runningTotalStyle = { width: '80px', textAlign: 'right', fontWeight: 'bold', color: '#b30000', fontSize: '1.1rem' };

const watermarkFixedContainerStyle = {
  position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
  pointerEvents: 'none', zIndex: 10, display: 'flex', justifyContent: 'center'
};

const watermarkStickyTextStyle = {
  position: 'sticky', top: '50vh', height: 'fit-content',
  fontSize: '2.5rem', fontWeight: 'bold', color: 'rgba(0,0,0,0.18)',
  transform: 'rotate(-15deg)', textAlign: 'center', whiteSpace: 'pre-wrap',
  lineHeight: '1.2'
};

const zoneBadgeStyle = (val) => ({
    minWidth: '35px', height: '26px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '0 8px', fontSize: '0.85rem', fontWeight: 'bold', color: '#fff',
    backgroundColor: getColorForZoneValue(val),
    border: '0.5px solid #000'
});

const shotBadgeStyle = (val) => ({
    width: '28px', height: '28px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '0.85rem', fontWeight: 'bold', color: '#fff', backgroundColor: getColorForZoneValue(val)
});

const centerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#666' };

export default CompetitorResultView;
